import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from 'config';
import { PolicyRequest, PolicyResponse } from 'types/policy';

import { defaultHeadersCommercialInsurance } from './defaultHeaders';
import { createCustomBaseQuery } from './utils/customBaseQuery';

export interface PolicyGetRequest {
  quoteNumber: string;
  email: string;
  accessToken: string;
}

export interface PolicyUpdateRequest {
  quoteNumber: string;
  policyData: PolicyRequest;
}

export interface PolicyBindRequest {
  quoteNumber: string;
  policyData: PolicyRequest;
}

// Use Common Base Query
const customBaseQuery = createCustomBaseQuery({
  baseUrl: config.msCommercialInsApi,
  defaultHeaders: defaultHeadersCommercialInsurance,
  reducerPath: 'quotesApi',
});

/* Define a service using a base URL and expected endpoints */
export const quotesApi = createApi({
  reducerPath: 'quotesApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getQuote: builder.query<PolicyResponse, PolicyGetRequest>({
      query: ({ quoteNumber, email, accessToken }) => ({
        url: `/quotes/${quoteNumber}?email=${email}&accessToken=${accessToken}`,
        method: 'GET',
      }),
    }),
    saveQuote: builder.mutation<PolicyResponse, PolicyRequest>({
      query: (body) => ({
        url: '/quotes',
        method: 'POST',
        body,
      }),
    }),
    updateQuote: builder.mutation<PolicyResponse, PolicyUpdateRequest>({
      query: ({ quoteNumber, policyData: body }) => ({
        url: `/quotes/${quoteNumber}`,
        method: 'PUT',
        body,
      }),
    }),
    bind: builder.mutation<PolicyResponse, PolicyBindRequest>({
      query: ({ quoteNumber, policyData: body }) => ({
        url: `/quotes/${quoteNumber}/bind`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetQuoteQuery, useSaveQuoteMutation, useUpdateQuoteMutation, useBindMutation } =
  quotesApi;
